// Copyright (c) Ping. All rights reserved.
//
// Web variant of the chat-home nav-rail icons (Figma node 3281:98498).
// react-native-svg has no runtime under react-native-web (the project
// aliases lucide-react-native to lucide-react and never installs the
// native SVG package on web), so we encode the parametrised SVG as a
// `data:image/svg+xml;base64,…` URI and feed it to `<Image>`. macOS
// uses the `.macos.tsx` sibling and renders the same XML via `SvgXml`.

import { Image } from 'react-native';
import { getNavIconSvg, type NavIconName } from './navIconSvgs';

export interface NavIconProps {
	readonly name: NavIconName;
	readonly size?: number;
	readonly color: string;
	readonly accessibilityLabel?: string;
}

export function NavIcon({ name, size = 24, color, accessibilityLabel }: NavIconProps): JSX.Element {
	const svg = getNavIconSvg(name, color);
	// `btoa` is available in browsers; the SVG strings are pure ASCII so
	// no unicode workaround is needed.
	const uri =
		typeof btoa !== 'undefined'
			? `data:image/svg+xml;base64,${btoa(svg)}`
			: `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
	return (
		<Image
			source={{ uri }}
			accessibilityIgnoresInvertColors
			accessibilityLabel={accessibilityLabel ?? name}
			style={{ width: size, height: size }}
			resizeMode="contain"
		/>
	);
}
